import { render } from "./HtmlEditor.vue?vue&type=template&id=22a844a9"
import script from "./HtmlEditor.vue?vue&type=script&lang=js"
export * from "./HtmlEditor.vue?vue&type=script&lang=js"

import "./HtmlEditor.vue?vue&type=style&index=0&id=22a844a9&lang=css"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__